import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUser } from "../../constant/utils";

type UserState = {
    loginUser: any;
    isLoggedIn: boolean;
    token:any;
};

let initialState: UserState = {
    loginUser: getUser(),
    isLoggedIn: !!localStorage.getItem("oqu"),
    token:localStorage.getItem("oqu"),
};
const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        loginResponse(state, action: PayloadAction<any>) {
            state.loginUser = action.payload;
            state.isLoggedIn = true;
        },
        vendorRegisterResponse(state, action: PayloadAction<any>) {
        },
        partnerRegisterResponse(state, action: PayloadAction<any>) {
        },
        logoutResponse(state, action: PayloadAction<any>) {
            state.loginUser = action.payload;
            state.isLoggedIn = false;
        },
    },
});

export const { loginResponse, logoutResponse,vendorRegisterResponse,partnerRegisterResponse } = userSlice.actions;

export default userSlice.reducer;
